import { FilesResponseModel } from "../pages/shared/models/api/files-response.model";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function uploadFile(data: FormData) {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/files/create`,
      data,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function getFiles(page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/files/my?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function getUserFiles(userId: number, page?: number, limit?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    if (page) {
      params.append("page", "" + page);
    }

    return axiosInstance
      .get(`${API_URL}/files/user/${userId}`, {
        params,
        ...authorizationHeader,
      })
      .then((result) => result.data as FilesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

async function getFileById(fileId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(`${API_URL}/files/${fileId}`, authorizationHeader);
  } catch (error) {
    console.error(error);
  }
}

async function downloadFileById(fileId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/files/download/${fileId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function removeFileById(fileId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/files/${fileId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  token = token ? token.replaceAll('"', "") : "";
  const refreshToken = localStorage.getItem("refresh_token");
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
      "Content-Type": "multipart/form-data",
    },
  };
}

export default {
  uploadFile,
  getFiles,
  getFileById,
  getUserFiles,
  removeFileById,
  downloadFileById,
};
